import { Box, Flex, chakra } from '@chakra-ui/react';

export interface TabItem {
  id: string;
  label: string;
}

interface VolunteersTabsProps {
  tabs: TabItem[];
  activeTab: string;
  onChange: (tabId: string) => void;
  /** Bottom margin for the control (default matches existing call sites). */
  mb?: string;
  /** Accessible name for the tab group. */
  ariaLabel?: string;
}

export function VolunteersTabs({
  tabs,
  activeTab,
  onChange,
  mb = '4',
  ariaLabel,
}: VolunteersTabsProps) {
  const activeIndex = Math.max(
    0,
    tabs.findIndex((tab) => tab.id === activeTab),
  );
  const segmentWidth = 100 / Math.max(tabs.length, 1);

  return (
    <Flex
      role="tablist"
      aria-label={ariaLabel}
      bg="volyx.lightGray"
      borderRadius="3xl"
      p="1.5"
      gap="1"
      mb={mb}
      border="1px solid"
      borderColor="volyx.mediumGray"
      boxShadow="0 1px 3px rgba(0,0,0,0.08)"
      position="relative"
      overflow="hidden"
    >
      {tabs.length > 0 && (
        <Box
          position="absolute"
          top="1.5"
          bottom="1.5"
          borderRadius="2xl"
          bg="volyx.action"
          boxShadow="0 4px 10px rgba(0,0,0,0.18)"
          transition="all 0.25s ease-in-out"
          style={{
            width: `calc(${segmentWidth}% - 0.75rem)`,
            left: `calc(${segmentWidth * activeIndex}% + 0.375rem)`,
          }}
        />
      )}
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <chakra.button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            flex="1"
            py="2"
            borderRadius="2xl"
            fontSize="sm"
            fontWeight="semibold"
            border="none"
            cursor="pointer"
            bg="transparent"
            color={isActive ? 'white' : 'volyx.textSecondary'}
            transition="color 0.2s ease-in-out"
            zIndex={1}
            _hover={!isActive ? { color: 'volyx.primary' } : undefined}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
          </chakra.button>
        );
      })}
    </Flex>
  );
}
